/* eslint-disable import/prefer-default-export */
import { css } from "@emotion/react";
import colors from "./colors";

export const contentCss = css`
  border-radius: 4px;
  background-color: ${colors.white};
  padding: 32px 24px;
`;
